import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader'; // Import the AdminHeader component

function AdminLayout({ children }) {
  return (
    <div className="flex flex-col h-screen"> {/* Changed to flex-col for stacking header and content */}
      <AdminHeader /> {/* Render the AdminHeader component */}
      <div className="flex overflow-y-hidden"> {/* horizontal flex container for sidebar and content */}
        <AdminSidebar />
        <div className="flex-1 overflow-y-auto"> {/* Main content scrollable */}
          {children}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
